var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RepeatRule } from "../models/reservation/reservation.model";
import { addDays, addMinutes, diffInMinutes, endOfDay, isAfter } from "./date.util";
import { useResources } from "./hooks/resources/useResources";
import { useService } from "./hooks/services/useServices";
import { useTranslation } from "react-i18next";
import { findProfileById } from "./profile.util";
export { getReservationDisplayGuestCounts, sumGuestCountsByAgeCategory, } from "./reservationGuestCounts.util";
export { getOrderedReservationProfileIds, getPrimaryProfile, getPrimaryProfileId, } from "./reservationProfile.util";
export var createMultidayReservations = function (reservation, until, rule, customDates) {
    if (!reservation || !until || !rule)
        return [];
    var fromDate = reservation === null || reservation === void 0 ? void 0 : reservation.expectedStartDate;
    var updatedTableReservation = __assign(__assign({}, reservation), { repeat: rule });
    var dates = [];
    var tmpDate;
    var tmpUntil = until;
    tmpUntil = tmpUntil && endOfDay(tmpUntil);
    if (rule !== RepeatRule.CUSTOM) {
        if (tmpUntil) {
            switch (rule) {
                case RepeatRule.EVERY_DAY:
                    tmpDate = addDays(fromDate, 1);
                    while (!isAfter(tmpDate, tmpUntil)) {
                        dates.push(tmpDate);
                        tmpDate = addDays(tmpDate, 1);
                    }
                    break;
                // Hiding others as suggested by product
                // case RepeatRule.EVERY_SECOND_DAY:
                //     tmpDate = addDays(fromDate, 2)
                //     while (!isAfter(tmpDate, tmpUntil)) {
                //         dates.push(tmpDate)
                //         tmpDate = addDays(tmpDate, 2)
                //     }
                //     break
                // case RepeatRule.EVERY_WEEK:
                //     tmpDate = addWeeks(fromDate, 1)
                //     while (!isAfter(tmpDate, tmpUntil)) {
                //         dates.push(tmpDate)
                //         tmpDate = addWeeks(tmpDate, 1)
                //     }
                //     break;
                // case RepeatRule.EVERY_2_WEEKS:
                //     tmpDate = addWeeks(fromDate, 2)
                //     while (!isAfter(tmpDate, tmpUntil)) {
                //         dates.push(tmpDate)
                //         tmpDate = addWeeks(tmpDate, 2)
                //     }
                //     break;
                // case RepeatRule.EVERY_3_WEEKS:
                //     tmpDate = addWeeks(fromDate, 3)
                //     while (!isAfter(tmpDate, tmpUntil)) {
                //         dates.push(tmpDate)
                //         tmpDate = addWeeks(tmpDate, 3)
                //     }
                //     break;
                // case RepeatRule.EVERY_4_WEEKS:
                //     tmpDate = addWeeks(fromDate, 4)
                //     while (!isAfter(tmpDate, tmpUntil)) {
                //         dates.push(tmpDate)
                //         tmpDate = addWeeks(tmpDate, 4)
                //     }
                //     break;
                // case RepeatRule.EVERY_5_WEEKS:
                //     tmpDate = addWeeks(fromDate, 5)
                //     while (!isAfter(tmpDate, tmpUntil)) {
                //         dates.push(tmpDate)
                //         tmpDate = addWeeks(tmpDate, 5)
                //     }
                //     break;
                // case RepeatRule.EVERY_6_WEEKS:
                //     tmpDate = addWeeks(fromDate, 6)
                //     while (!isAfter(tmpDate, tmpUntil)) {
                //         dates.push(tmpDate)
                //         tmpDate = addWeeks(tmpDate, 6)
                //     }
                //     break;
                // case RepeatRule.EVERY_7_WEEKS:
                //     tmpDate = addWeeks(fromDate, 7)
                //     while (!isAfter(tmpDate, tmpUntil)) {
                //         dates.push(tmpDate)
                //         tmpDate = addWeeks(tmpDate, 7)
                //     }
                //     break;
                // case RepeatRule.EVERY_8_WEEKS:
                //     tmpDate = addWeeks(fromDate, 8)
                //     while (!isAfter(tmpDate, tmpUntil)) {
                //         dates.push(tmpDate)
                //         tmpDate = addWeeks(tmpDate, 8)
                //     }
                //     break;
                // case RepeatRule.EVERY_MONTH:
                //     tmpDate = addMonths(fromDate, 1)
                //     while (!isAfter(tmpDate, tmpUntil)) {
                //         dates.push(tmpDate)
                //         tmpDate = addMonths(tmpDate, 1)
                //     }
                //     break;
                // case RepeatRule.EVERY_6_MONTHS:
                //     tmpDate = addMonths(fromDate, 6)
                //     while (!isAfter(tmpDate, tmpUntil)) {
                //         dates.push(tmpDate)
                //         tmpDate = addMonths(tmpDate, 6)
                //     }
                //     break;
                // case RepeatRule.EVERY_YEAR:
                //     tmpDate = addYears(fromDate, 1)
                //     while (!isAfter(tmpDate, tmpUntil)) {
                //         dates.push(tmpDate)
                //         tmpDate = addYears(tmpDate, 1)
                //     }
                //     break;
                // case RepeatRule.EVERY_WEEKDAY:
                //     tmpDate = addDays(fromDate, 1)
                //     while (!isAfter(tmpDate, tmpUntil)) {
                //         if (tmpDate.getDay() > 0 && tmpDate.getDay() < 6) {
                //             dates.push(tmpDate)
                //         }
                //         tmpDate = addDays(tmpDate, 1)
                //     }
                //     break;
                // case RepeatRule.EVERY_WEEKEND:
                //     tmpDate = addDays(fromDate, 1)
                //     while (!isAfter(tmpDate, tmpUntil)) {
                //         if (tmpDate.getDay() === 0 || tmpDate.getDay() === 6) {
                //             dates.push(tmpDate)
                //         }
                //         tmpDate = addDays(tmpDate, 1)
                //     }
                //     break;
                // case RepeatRule.EVERY_MONTH_SAME_FIRST_WEEKDAY: {
                //     tmpDate = addMonths(fromDate, 1)
                //     tmpDate = addDays(tmpDate, -diffInDays(tmpDate, startOfMonth(tmpDate)))
                //     const diffToDate = reservation?.expectedStartDate?.getDay()! - tmpDate.getDay()
                //     if (diffToDate > 0) {
                //         tmpDate = addDays(tmpDate, diffToDate)
                //     } else if (diffToDate < 0) {
                //         tmpDate = addDays(tmpDate, 7 + diffToDate)
                //     }
                //
                //     while (!isAfter(tmpDate, tmpUntil)) {
                //         dates.push(tmpDate)
                //         tmpDate = addMonths(tmpDate, 1)
                //         tmpDate = addDays(tmpDate, -diffInDays(tmpDate, startOfMonth(tmpDate)))
                //
                //         const diffToDate = reservation?.expectedStartDate?.getDay()! - tmpDate.getDay()
                //         if (diffToDate > 0) {
                //             tmpDate = addDays(tmpDate, diffToDate)
                //         } else if (diffToDate < 0) {
                //             tmpDate = addDays(tmpDate, 7 + diffToDate)
                //         }
                //     }
                // }
                //     break;
                // case RepeatRule.EVERY_MONTH_SAME_LAST_WEEKDAY: {
                //     tmpDate = addMonths(fromDate, 1)
                //     tmpDate = addDays(tmpDate, diffInDays(endOfMonth(tmpDate), tmpDate))
                //     const diffToDate = tmpDate.getDay() - reservation?.expectedStartDate?.getDay()!
                //     if (diffToDate > 0) {
                //         tmpDate = addDays(tmpDate, -diffToDate)
                //     } else if (diffToDate < 0) {
                //         tmpDate = addDays(tmpDate, -(7 + diffToDate))
                //     }
                //
                //     while (!isAfter(tmpDate, tmpUntil)) {
                //         dates.push(tmpDate)
                //         tmpDate = addMonths(tmpDate, 1)
                //         tmpDate = addDays(tmpDate, diffInDays(endOfMonth(tmpDate), tmpDate))
                //
                //         const diffToDate = tmpDate.getDay() - reservation?.expectedStartDate?.getDay()!
                //         if (diffToDate > 0) {
                //             tmpDate = addDays(tmpDate, -diffToDate)
                //         } else if (diffToDate < 0) {
                //             tmpDate = addDays(tmpDate, -(7 + diffToDate))
                //         }
                //     }
                // }
                //     break;
            }
        }
    }
    else {
        dates = customDates || [];
    }
    var multidayReservations = [reservation];
    dates.forEach(function (date) {
        var originalDuration = diffInMinutes(reservation === null || reservation === void 0 ? void 0 : reservation.expectedEndDate, reservation === null || reservation === void 0 ? void 0 : reservation.expectedStartDate);
        multidayReservations.push(__assign(__assign({}, updatedTableReservation), { expectedStartDate: date, expectedEndDate: addMinutes(date, originalDuration) }));
    });
    return multidayReservations;
};
export var useCheckLinkedResources = function (reservation) {
    var t = useTranslation().t;
    var resources = useResources((reservation === null || reservation === void 0 ? void 0 : reservation.resourceIds) || []).filter(function (r) { return !r.parentId; });
    var service = useService(reservation === null || reservation === void 0 ? void 0 : reservation.serviceId);
    if (!service || !resources)
        return {
            hasNotLinkedResources: false,
            notLinkedResources: [],
            notLinkedResourceNames: ''
        };
    var resourcesNotLinked = resources.filter(function (resource) { var _a; return !((_a = service.resourceIds) === null || _a === void 0 ? void 0 : _a.includes(resource.id)); });
    return {
        hasNotLinkedResources: resourcesNotLinked.length > 0,
        notLinkedResources: resourcesNotLinked,
        notLinkedResourceNames: resourcesNotLinked.map(function (resource) { return resource.name || ''; }).join(', '),
        message: t('The following resources are not linked to the service', {
            service: service === null || service === void 0 ? void 0 : service.name,
            resources: resourcesNotLinked.map(function (resource) { return resource.name || ''; }).join(', ')
        })
    };
};
export var formatReservationProfileName = function (reservation, profiles, options) {
    var _a, _b, _c, _d;
    var primaryProfileId = (options === null || options === void 0 ? void 0 : options.highlightPrimary)
        && reservation.primaryProfileId
        && !((_a = reservation.profileIds) === null || _a === void 0 ? void 0 : _a.includes(reservation.primaryProfileId))
        ? reservation.primaryProfileId : undefined;
    var primaryName = '';
    if (primaryProfileId) {
        var primaryProfile = findProfileById(profiles, primaryProfileId);
        primaryName = [primaryProfile === null || primaryProfile === void 0 ? void 0 : primaryProfile.academicTitle, primaryProfile === null || primaryProfile === void 0 ? void 0 : primaryProfile.lastName, primaryProfile === null || primaryProfile === void 0 ? void 0 : primaryProfile.firstName].filter(Boolean).join(' ');
    }
    var otherNames = [];
    (_b = reservation.profileIds) === null || _b === void 0 ? void 0 : _b.forEach(function (profileId) {
        if (primaryProfileId && profileId === primaryProfileId)
            return;
        var profile = findProfileById(profiles, profileId);
        var name = [profile === null || profile === void 0 ? void 0 : profile.academicTitle, profile === null || profile === void 0 ? void 0 : profile.lastName, profile === null || profile === void 0 ? void 0 : profile.firstName].filter(Boolean).join(' ');
        name && otherNames.push(name);
    });
    if (primaryName) {
        var others = otherNames.join(", ");
        return others ? "[".concat(primaryName, "] ").concat(others) : "[".concat(primaryName, "]");
    }
    var names = otherNames.join(", ");
    if (names)
        return names;
    if (reservation.reservationRequestData) {
        return [(_c = reservation.reservationRequestData) === null || _c === void 0 ? void 0 : _c.lastName, (_d = reservation.reservationRequestData) === null || _d === void 0 ? void 0 : _d.firstName].filter(Boolean).join(' ');
    }
    return '-';
};
export var sortActiveStays = function (activeStays) {
    var today = new Date().toISOString().split('T')[0];
    var parseDate = function (dateStr) {
        return dateStr ? new Date(dateStr) : null;
    };
    // First try to find a stay that is active today
    var currentStay = activeStays === null || activeStays === void 0 ? void 0 : activeStays.find(function (stay) {
        var start = parseDate(stay.startDay);
        var end = parseDate(stay.endDay);
        return start && end && start <= new Date(today) && new Date(today) <= end;
    });
    if (currentStay)
        return currentStay;
    // If not - then the next most relevant is the future stay
    var futureStays = activeStays === null || activeStays === void 0 ? void 0 : activeStays.filter(function (stay) { return parseDate(stay.startDay) > new Date(today); }).sort(function (a, b) { return parseDate(a.startDay).getTime() - parseDate(b.startDay).getTime(); });
    if (futureStays === null || futureStays === void 0 ? void 0 : futureStays.length)
        return futureStays === null || futureStays === void 0 ? void 0 : futureStays[0];
    // If not - then the next most relevant is the past stay
    var pastStays = activeStays === null || activeStays === void 0 ? void 0 : activeStays.filter(function (stay) { return parseDate(stay.endDay) < new Date(today); }).sort(function (a, b) { return parseDate(b.endDay).getTime() - parseDate(a.endDay).getTime(); });
    if (pastStays === null || pastStays === void 0 ? void 0 : pastStays.length)
        return pastStays === null || pastStays === void 0 ? void 0 : pastStays[0];
    return undefined;
};
